/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import DataTableComponent, { ColumnOption } from "../../../../common/DataTable";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "../../../../../util/axiosconfig";

import { Toast } from "primereact/toast";
import {
  dateBodyTemplate,
  descriptionBodyTemplate,
  statusBodyTemplate,
  tableHeaderTemplate,
  totalLeavesBodyTemplate,
} from "../LeavesTemplates";
import { fetchMyLeavesData } from "./fetchData";
import { getErrorMessage } from "../../../../../helper/getResponseMessage";
import { showError, showSuccess } from "../../../../../util/ShowStatus";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import {
  LEAVE_DAY_TYPES,
  LEAVE_HALF_DAY_TYPES,
  LEAVE_TYPES,
} from "../../../../../util/constants";
import { ConfirmDialog } from "primereact/confirmdialog";
import { DeletePopupTrashIcon } from "../../../../../assets/SVGs/DeletePopupTrashIcon";
import { RevokeIconSVG } from "../../../../../assets/SVGs/RevokeIconSVG";

const MyLeaves = ({
  isAddLeaveDialogVisible,
  setIsAddLeaveDialogVisible,
  formValues,
  setFormValues,
  filters,
  setFilters,
  leaveTypes,
}: any) => {
  const toast = useRef<Toast>(null);

  const [myLeavesDataLoading, setMyLeavesDataLoading] =
    useState<boolean>(false);
  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "createdDate",
    sortOrder: false,
  });

  const [isAddButtonDisabled, setIsAddButtonDisabled] =
    useState<boolean>(false);

  const [formErrors, setFormErrors] = useState<any>({
    leaveType: null,
    startDate: null,
    endDate: null,
    leaveDayType: null,
    departments: null,
    description: null,
  });

  const [selectedDates, setSelectedDates] = useState<any>([]); // To hold selected dates for the date range picker
  const [availableUsedLeaveData, setAvailableUsedLeaveData] = useState<any>({
    availableLeaves: null,
    usedLeaves: null,
    pendingLeaves: null,
    holidayCount: null,
  }); // To hold available and used leave data
  const [formType, setFormType] = useState<string>("add"); // To track if the form is for adding or editing a vehicle
  const [actionType, setActionType] = useState<string>("delete"); // To track if the form is for adding or editing a vehicle

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] =
    useState<boolean>(false);
  const [showMaxAllowedDatesError, setShowMaxAllowedDatesError] =
    useState<boolean>(false);
  const [isDeleteButtonDisabled, setIsDeleteButtonDisabled] =
    useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<number>(0);
  const [revokeId, setRevokeId] = useState<number>(0);

  const [showManagerComments, setShowManagerComments] =
    useState<boolean>(false);

  const [approveRejectComments, setApproveRejectComments] = useState<
    string | null
  >(null);

  const [first, setFirst] = useState<number>(0);
  const [size, setSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(10); // To hold the total number of records
  const page = 0; // Current page index (0-based)

  const [myLeavesData, setMyLeavesData] = useState<any[]>([]);
  useEffect(() => {
    if (filters.startDate && filters.endDate) {
      fetchMyLeavesData(
        page,
        size,
        setMyLeavesData,
        setAvailableUsedLeaveData,
        setTotalRecords,
        setMyLeavesDataLoading,
        filters,
        sortFilter,
        toast
      );
    }
  }, [
    sortFilter,
    filters?.startDate,
    filters?.endDate,
    filters?.leaveType,
    filters?.status,
  ]);

  const InvoiceDateConst = (date: (Date | null)[]): void => {
    setShowMaxAllowedDatesError(false);
    const leaveType = leaveTypes.find(
      (lt: any) => lt.leaveType === formValues.leaveType?.leaveType
    );
    // Calculate max allowed leave days
    const availableLeaves = availableUsedLeaveData.availableLeaves ?? 0;
    const pendingLeaves = availableUsedLeaveData.pendingLeaves ?? 0;
    const maxAllowedLeaveDays = availableLeaves - pendingLeaves;

    // Convert to UTC before getting time
    const toUTC = (d: Date | null) =>
      d
        ? new Date(
            Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0)
          )
        : null;

    const formattedStartDate = date[0]
      ? Math.floor(toUTC(date[0])!.getTime() / 1000.0)
      : null;
    const formattedEndDate = date[1]
      ? Math.floor(toUTC(date[1])!.getTime() / 1000.0)
      : null;

    const calculateBusinessDays = (startDate: Date, endDate: Date): number => {
      let count = 0;
      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const day = currentDate.getUTCDay();
        if (day !== 0 && day !== 6) {
          // Skip Sundays (0) and Saturdays (6)
          count++;
        }
        currentDate.setUTCDate(currentDate.getUTCDate() + 1);
      }
      return count;
    };

    if (formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY) {
      if (formattedStartDate) {
        // For half day, total leave days is always 0.5
        const newTotalLeaveDays = 0.5;

        if (newTotalLeaveDays > maxAllowedLeaveDays) {
          if (leaveType && leaveType.leaveType === LEAVE_TYPES.SICK_LEAVE) {
            setFormValues((prev: any) => ({
              ...prev,
              startDate: formattedStartDate,
              endDate: formattedStartDate,
              totalLeaveDays: newTotalLeaveDays,
            }));
            return;
          } else {
            setFormErrors((prev: any) => ({
              ...prev,
              totalLeaveDays: `Total leave days cannot exceed ${maxAllowedLeaveDays} days`,
            }));
            setShowMaxAllowedDatesError(true);
            setSelectedDates([]); // Reset dates when limit exceeded
            setFormValues((prev: any) => ({
              ...prev,
              startDate: null,
              endDate: null,
              totalLeaveDays: null,
            }));
            return;
          }
        } else {
          setFormErrors((prev: any) => ({
            ...prev,
            totalLeaveDays: null,
          }));
        }
        setSelectedDates([date[0], date[0]]);
        setFormValues((prev: any) => ({
          ...prev,
          startDate: formattedStartDate,
          endDate: formattedStartDate,
          totalLeaveDays: newTotalLeaveDays,
        }));
      }
    } else {
      if (formattedStartDate && formattedEndDate) {
        const startDate = new Date(formattedStartDate * 1000);
        const endDate = new Date(formattedEndDate * 1000);
        const differenceInDays = calculateBusinessDays(startDate, endDate);

        if (differenceInDays > maxAllowedLeaveDays) {
          if (
            leaveType &&
            // (leaveType.leaveType === LEAVE_TYPES.ABSCENCE_LEAVE ||
            //   leaveType.leaveType === LEAVE_TYPES.SICK_LEAVE)
            leaveType.leaveType === LEAVE_TYPES.SICK_LEAVE
          ) {
            setFormValues((prev: any) => ({
              ...prev,
              startDate: formattedStartDate,
              endDate: formattedEndDate,
              totalLeaveDays: differenceInDays,
            }));
            return;
          } else {
            setFormErrors((prev: any) => ({
              ...prev,
              totalLeaveDays: `Total leave days cannot exceed ${maxAllowedLeaveDays} days`,
            }));
            setShowMaxAllowedDatesError(true);
            setSelectedDates([]); // Reset dates when limit exceeded
            setFormValues((prev: any) => ({
              ...prev,
              startDate: null,
              endDate: null,
              totalLeaveDays: null,
            }));
            return;
          }
        } else {
          setFormErrors((prev: any) => ({
            ...prev,
            totalLeaveDays: null,
          }));
        }
        setFormValues((prev: any) => ({
          ...prev,
          totalLeaveDays: differenceInDays,
        }));
      }
      setSelectedDates(date);
      setFormValues((prev: any) => ({
        ...prev,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      }));
    }
  };

  const validateForm = () => {
    const errors: Partial<Record<string, string>> = {};

    if (!formValues.leaveType) {
      errors.leaveType = "Leave type is required";
    }
    if (!formValues.startDate) {
      errors.startDate = "Start date is required";
    }
    if (!formValues.endDate) {
      errors.endDate = "End date is required";
    }
    if (!formValues.leaveDayType) {
      errors.leaveDayType = "Leave day type is required";
    }
    if (
      formValues?.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY &&
      !formValues.halfDayPeriod
    ) {
      errors.halfDayPeriod = "Half day period is required";
    }
    if (formValues.startDate && formValues.endDate) {
      const startDate = new Date(formValues.startDate * 1000);
      const endDate = new Date(formValues.endDate * 1000);
      if (startDate > endDate) {
        errors.startDate = "Start date cannot be after end date";
        errors.endDate = "End date cannot be before start date";
      }
    }
    if (formValues.totalLeaveDays && formValues.totalLeaveDays < 0) {
      errors.totalLeaveDays = "Total leave days cannot be negative";
    }
    // if (!formValues.departments || formValues.departments.length === 0) {
    //   errors.departments = "Department is required";
    // }
    if (!formValues.description || formValues.description.trim() === "") {
      errors.description = "Description is required";
    }
    // if (formValues.totalLeaveDays && formValues.totalLeaveDays > 30) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 30 days";
    // }
    // if (formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY && formValues.totalLeaveDays > 1) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 1 day for Half Day";
    // }
    // if (formValues.leaveType === "Sick Leave" && formValues.totalLeaveDays > 3) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 3 days for Sick Leave";
    // }
    // if (formValues.leaveType === "Annual Leave" && formValues.totalLeaveDays > 30) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 30 days for Annual Leave";
    // }
    // if (formValues.leaveType === "Casual Leave" && formValues.totalLeaveDays > 5) {
    //   errors.totalLeaveDays = "Total leave days cannot exceed 5 days for Casual Leave";
    // }
    setFormErrors((prev: any) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const handleAddUpdateMyLeaves = async (type?: string) => {
    if (!validateForm()) return; // Stop submission if validation fails
    const params: any = {};
    try {
      if (formType === "update") {
        params.leaveHistoryID = formValues.leaveHistoryID;
      }
      params.userID = parseInt(localStorage.userID);
      if (formValues.leaveType) params.leaveTypeID = formValues.leaveType.id;
      if (formValues.startDate) params.startDate = formValues.startDate;
      if (formValues.endDate) params.endDate = formValues.endDate;
      if (formValues.totalLeaveDays)
        params.totalLeaveDays = formValues.totalLeaveDays;
      if (formValues.leaveDayType)
        params.leaveDayType = formValues.leaveDayType;
      if (
        formValues.halfDayPeriod &&
        formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY
      )
        params.dayPart = formValues.halfDayPeriod;
      if (formValues.description) params.description = formValues.description;
      params.isWeb = true;

      setIsAddButtonDisabled(true);
      type === "add"
        ? await axios.post("tl-user-leave/add-leave", params)
        : await axios.post("tl-user-leave/edit-leave-detail", params);
      setFormValues({
        leaveType: null,
        startDate: null,
        endDate: null,
        totalLeaveDays: null,
        leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
        halfDayPeriod: LEAVE_HALF_DAY_TYPES.AM,
        departments: null,
        description: null,
      });
      setFormErrors({
        leaveType: null,
        startDate: null,
        endDate: null,
        leaveDayType: null,
        departments: null,
        description: null,
      });
      setSelectedDates([]);
      setFirst(page);
      fetchMyLeavesData(
        page,
        size,
        setMyLeavesData,
        setAvailableUsedLeaveData,
        setTotalRecords,
        setMyLeavesDataLoading,
        filters,
        sortFilter,
        toast
      );
      setFormErrors({
        leaveType: null,
        startDate: null,
        endDate: null,
        leaveDayType: null,
        departments: null,
        description: null,
      });
      setIsAddButtonDisabled(false);
      setIsAddLeaveDialogVisible(false);
      setFormType("add");
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      setIsAddButtonDisabled(false);
    }
  };

  const handleEditLeave = (rowData: any) => {
    setFormType("update");
    setSelectedDates([
      new Date(rowData.startDate * 1000),
      new Date(rowData.endDate * 1000),
    ]);
    setFormValues({
      leaveHistoryID: rowData.id,
      leaveType: leaveTypes.find((lt: any) => lt.id === rowData.leaveTypeID),
      startDate: rowData.startDate,
      endDate: rowData.endDate,
      totalLeaveDays: rowData.totalLeaveDays,
      leaveDayType: rowData.leaveDayType,
      halfDayPeriod: rowData.dayPart,
      description: rowData.description,
    });
    setIsAddLeaveDialogVisible(true);
  };

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setFirst(event.first);
    setSize(event.rows); // Set the number of rows per page
    const currentPage = Math.floor(event.first / event.rows); // Calculate the current page index
    fetchMyLeavesData(
      currentPage,
      event.rows,
      setMyLeavesData,
      setAvailableUsedLeaveData,
      setTotalRecords,
      setMyLeavesDataLoading,
      filters,
      sortFilter,
      toast
    );
  };

  const myLeavessColumns: ColumnOption[] = [
    {
      field: "startDate",
      header: tableHeaderTemplate("Start Date", "startDate", setSortFilter),
      body: (e: any) => dateBodyTemplate(e, "startDate"),
      visible: true,
    },
    {
      field: "endDate",
      header: tableHeaderTemplate("End Date", "endDate", setSortFilter),
      body: (e: any) => dateBodyTemplate(e, "endDate"),
      visible: true,
    },
    {
      field: "totalLeaveDays",
      header: tableHeaderTemplate(
        "Total Leave Days",
        "totalLeaveDays",
        setSortFilter
      ),
      body: totalLeavesBodyTemplate,
      visible: true,
    },
    {
      field: "leaveTypeID",
      header: tableHeaderTemplate("Type", "leaveTypeID", setSortFilter),
      visible: true,
      body: (e: any) => {
        return (
          <span className="tw-text-[#64748B] tw-text-sm">
            {e.tLLeaveType.leaveType}
          </span>
        );
      },
    },
    {
      field: "description",
      header: tableHeaderTemplate("Description", "description", setSortFilter),
      visible: true,
      body: descriptionBodyTemplate,
    },
    {
      field: "status",
      header: tableHeaderTemplate("Status", "status", setSortFilter),
      visible: true,
      body: (e: any) =>
        statusBodyTemplate(
          e,
          handleEditLeave,
          setIsConfirmDialogOpen,
          setDeleteId,
          setRevokeId,
          setActionType,
          setShowManagerComments,
          setApproveRejectComments
        ),
    },
  ];

  const handleDeleteRevoke = async () => {
    try {
      setIsDeleteButtonDisabled(true);
      const response =
        actionType === "delete"
          ? await axios.post(`tl-user-leave/deleteLeaveHistory/delete`, {
              leaveHistoryID: deleteId,
            })
          : await axios.post(`tl-user-leave/revoke-leave`, {
              leaveHistoryID: revokeId,
            });
      showSuccess(response.data.Message, toast);
      setIsConfirmDialogOpen(false);
      fetchMyLeavesData(
        page,
        size,
        setMyLeavesData,
        setAvailableUsedLeaveData,
        setTotalRecords,
        setMyLeavesDataLoading,
        filters,
        sortFilter,
        toast
      );
      setIsDeleteButtonDisabled(false);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setIsDeleteButtonDisabled(false);
      showError(errorMessage, toast);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        group="headless"
        visible={isConfirmDialogOpen}
        onHide={() => setIsConfirmDialogOpen(false)}
        message={
          <div className="tw-flex tw-flex-align-items-center tw-w-full tw-gap-3 tw-border-bottom-1 tw-surface-border">
            {actionType === "delete" ? (
              <DeletePopupTrashIcon />
            ) : (
              <RevokeIconSVG heightWidth={44} />
            )}
            <div className="tw-flex tw-flex-col">
              <span className="tw-text-2xl tw-font-bold tw-text-black">
                Confirmation
              </span>
              <span className="tw-text-lg">
                {`Are you sure you want to ${actionType} this record?`}
              </span>
            </div>
          </div>
        }
        footer={() => (
          <div className="flex gap-2">
            <Button
              onClick={() => setIsConfirmDialogOpen(false)}
              className="tw-rounded-lg tw-border tw-border-gray-300 tw-px-4 focus:tw-shadow-none hover:tw-bg-gray-200 tw-py-2 tw-font-medium tw-transition-all tw-duration-200"
            >
              Cancel
            </Button>
            <Button
              onClick={handleDeleteRevoke}
              className="tw-bg-primary hover:tw-bg-[#152846] tw-text-white focus:tw-shadow-none tw-rounded-lg tw-px-4 tw-py-2 tw-ml-2 tw-font-medium tw-transition-all tw-duration-200"
              disabled={isDeleteButtonDisabled}
            >
              {actionType === "delete" ? "Delete" : "Revoke"}
            </Button>
          </div>
        )}
      >
        <div className="tw-flex tw-justify-start tw-items-start tw-gap-4 tw-w-full">
          <div className="icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
                stroke="#9C1C21"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
            <h1 className="delete-title"> Confirmation</h1>
            <p className="delete-message">
              Are you sure you want to approve this leave?
            </p>
          </div>
        </div>
      </ConfirmDialog>
      <div className="tw-container tw-mx-auto">
        {myLeavesDataLoading ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        ) : (
          <>
            {/** Total time div */}
            <div className="tw-flex tw-gap-3 tw-py-2 tw-pl-[10px]">
              <span className="tw-font-semibold tw-mr-2 tw-text-[#64748B] tw-text-sm">
                Available Leaves :{" "}
                <span className="tw-text-[#00AFEE] tw-font-bold">
                  {availableUsedLeaveData.availableLeaves ?? ""}
                </span>
              </span>
              <span className="tw-font-semibold tw-mr-2 tw-text-[#64748B] tw-text-sm">
                Used Leaves :{" "}
                <span className="tw-text-[#00AFEE] tw-font-bold">
                  {availableUsedLeaveData.usedLeaves ?? ""}
                </span>
              </span>
              <span className="tw-font-semibold tw-mr-2 tw-text-[#64748B] tw-text-sm">
                Pending Leaves :{" "}
                <span className="tw-text-[#00AFEE] tw-font-bold">
                  {availableUsedLeaveData.pendingLeaves ?? "N/A"}
                </span>
              </span>
              <span className="tw-font-semibold tw-mr-2 tw-text-[#64748B] tw-text-sm">
                Statutory Holidays :{" "}
                <span className="tw-text-[#00AFEE] tw-font-bold">
                  {availableUsedLeaveData.holidayCount ?? ""}
                </span>
              </span>
            </div>

            <DataTableComponent
              rowData={myLeavesData}
              columns={myLeavessColumns}
              customClass="timelog-datatable"
            />
            <Paginator
              first={first}
              rows={size}
              totalRecords={totalRecords} // Set total records for pagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              onPageChange={onPageChange}
            />
          </>
        )}
        {/* Add Leave Dialog */}
        <Dialog
          header={formType === "add" ? "Add Leave" : "Update Leave"}
          visible={isAddLeaveDialogVisible}
          style={{ width: "24vw" }}
          onHide={() => {
            setFormValues({
              leaveType: null,
              startDate: null,
              endDate: null,
              totalLeaveDays: null,
              leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
              halfDayPeriod: LEAVE_HALF_DAY_TYPES.AM,
              departments: null,
              description: null,
            });
            setFormErrors({
              leaveType: null,
              startDate: null,
              endDate: null,
              leaveDayType: null,
              departments: null,
              description: null,
            });
            setSelectedDates([]);
            setFormType("add");
            setIsAddLeaveDialogVisible(false);
          }}
        >
          <div className="tw-flex tw-flex-col tw-gap-4">
            <div className="tw-flex tw-flex-col tw-gap-2">
              <label className="tw-font-medium">Leave Type</label>
              <Dropdown
                value={formValues.leaveType ?? ""}
                options={leaveTypes}
                onChange={(e) => {
                  setSelectedDates([]); // Reset the selected dates
                  setFormValues((prev: any) => ({
                    ...prev,
                    startDate: null,
                    endDate: null,
                    totalLeaveDays: null,
                  }));
                  setFormErrors((prev: any) => ({
                    ...prev,
                    leaveType: null,
                  }));
                  setFormValues((prev: any) => ({
                    ...prev,
                    leaveType: e.value,
                  }));
                }}
                optionLabel="leaveType"
                placeholder="Select Leave Type"
                className={`tw-border tw-border-solid ${
                  formErrors.leaveType
                    ? "tw-border-red-600"
                    : "tw-border-gray-400"
                } tw-rounded-md placeholder:tw-font-normal tw-w-full`}
              />
            </div>

            <div className="tw-flex tw-flex-col tw-gap-2">
              <label className="tw-font-medium">Select Date Range</label>
              <Calendar
                value={selectedDates ?? []}
                dateFormat="dd-mm-yy"
                onChange={(e) => {
                  e.stopPropagation();
                  setFormErrors((prev: any) => ({
                    ...prev,
                    startDate: null,
                    endDate: null,
                    totalLeaveDays: null,
                  }));
                  const selectedDates = e.value as (Date | null)[];
                  InvoiceDateConst(selectedDates);
                }}
                selectionMode="range"
                disabledDays={[0, 6]} // Disable Sundays and Saturdays
                className={`${
                  formErrors.startDate ||
                  formErrors.endDate ||
                  formErrors.totalLeaveDays
                    ? "tw-border-red-600"
                    : "tw-border-gray-400"
                } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                placeholder="Select Date Range"
                showIcon
                readOnlyInput
                hideOnRangeSelection
                minDate={
                  formValues.leaveType?.leaveType === LEAVE_TYPES.SICK_LEAVE
                    ? // || formValues.leaveType?.leaveType === LEAVE_TYPES.ABSCENCE_LEAVE
                      (() => {
                        const today = new Date();
                        const firstOfMonth = new Date(
                          today.getFullYear(),
                          today.getMonth(),
                          1
                        );
                        const sevenDaysAgo = new Date(today);
                        sevenDaysAgo.setDate(today.getDate() - 7);
                        return sevenDaysAgo < firstOfMonth
                          ? firstOfMonth
                          : sevenDaysAgo;
                      })()
                    : new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1
                      )
                } // Set min date to the 1st of the current month
                // Set max date to 7 days from current date only for Sick or Absence leave types
                maxDate={
                  formValues.leaveType?.leaveType === LEAVE_TYPES.SICK_LEAVE
                    ? // ||  formValues.leaveType?.leaveType === LEAVE_TYPES.ABSCENCE_LEAVE
                      new Date()
                    : undefined
                }
              />
              {showMaxAllowedDatesError && (
                <p className="tw-text-red-600 tw-text-sm tw-mt-1">
                  {formErrors?.totalLeaveDays}
                </p>
              )}
            </div>

            <div className="tw-flex tw-flex-col tw-gap-2">
              <label className="tw-font-medium">Day Type</label>
              <div className="tw-flex tw-bg-white tw-border tw-border-gray-400 tw-rounded-full tw-p- tw-w-full">
                <button
                  type="button"
                  className={`tw-flex-1 tw-py-2 tw-rounded-full tw-rounded-r-none tw-border-r-gray-400 tw-text-sm tw-font-medium ${
                    formValues.leaveDayType === LEAVE_DAY_TYPES.FULL_DAY
                      ? "tw-bg-[#e0f7ff] tw-text-black tw-border tw-border-[#bae6fd]"
                      : "tw-bg-white tw-text-gray-700"
                  }`}
                  onClick={() =>
                    setFormValues((prev: any) => ({
                      ...prev,
                      totalLeaveDays: 1,
                      leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
                    }))
                  }
                >
                  {formValues.leaveDayType === LEAVE_DAY_TYPES.FULL_DAY && `✓`}{" "}
                  {LEAVE_DAY_TYPES.FULL_DAY}
                </button>
                <button
                  type="button"
                  className={`tw-flex-1 tw-py-2 tw-rounded-full tw-rounded-l-none tw-border-l-gray-400 tw-text-sm tw-font-medium ${
                    formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY
                      ? "tw-bg-[#e0f7ff] tw-text-black tw-border tw-border-[#bae6fd]"
                      : "tw-bg-white tw-text-gray-700"
                  }`}
                  onClick={() => {
                    if (formValues.totalLeaveDays > 1) {
                      setFormErrors((prev: any) => ({
                        ...prev,
                        totalLeaveDays:
                          "Total leave days cannot exceed 1 day for Half Day",
                      }));
                      showError(
                        "Total leave days cannot exceed 1 day for Half Day",
                        toast
                      );
                      return;
                    }
                    setFormValues((prev: any) => ({
                      ...prev,
                      totalLeaveDays: 0.5,
                      leaveDayType: LEAVE_DAY_TYPES.HALF_DAY,
                    }));
                  }}
                >
                  {formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY && `✓`}{" "}
                  {LEAVE_DAY_TYPES.HALF_DAY}
                </button>
              </div>
              {/* Add AM/PM selection when half-day is chosen */}
              {formValues.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY && (
                <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-2">
                  <label className="tw-font-medium">Half Day Period</label>
                  <div
                    className={`${
                      formErrors.halfDayPeriod
                        ? "tw-border-red-600"
                        : "tw-border-gray-400"
                    } tw-flex tw-bg-white tw-border tw-border-gray-400 tw-rounded-full tw-p- tw-w-full`}
                  >
                    <button
                      type="button"
                      className={`tw-flex-1 tw-py-2 tw-rounded-full tw-rounded-r-none tw-border-r-gray-400 tw-text-sm tw-font-medium ${
                        formValues.halfDayPeriod === LEAVE_HALF_DAY_TYPES.AM
                          ? "tw-bg-[#e0f7ff] tw-text-black tw-border tw-border-[#bae6fd]"
                          : "tw-bg-white tw-text-gray-700"
                      }`}
                      onClick={() => {
                        setFormErrors((prev: any) => ({
                          ...prev,
                          halfDayPeriod: null,
                        }));
                        setFormValues((prev: any) => ({
                          ...prev,
                          halfDayPeriod: LEAVE_HALF_DAY_TYPES.AM,
                        }));
                      }}
                    >
                      {formValues.halfDayPeriod === LEAVE_HALF_DAY_TYPES.AM &&
                        `✓`}{" "}
                      {LEAVE_HALF_DAY_TYPES.AM}
                    </button>
                    <button
                      type="button"
                      className={`tw-flex-1 tw-py-2 tw-rounded-full tw-rounded-l-none tw-border-l-gray-400 tw-text-sm tw-font-medium ${
                        formValues.halfDayPeriod === LEAVE_HALF_DAY_TYPES.PM
                          ? "tw-bg-[#e0f7ff] tw-text-black tw-border tw-border-[#bae6fd]"
                          : "tw-bg-white tw-text-gray-700"
                      }`}
                      onClick={() => {
                        setFormErrors((prev: any) => ({
                          ...prev,
                          halfDayPeriod: null,
                        }));
                        setFormValues((prev: any) => ({
                          ...prev,
                          halfDayPeriod: LEAVE_HALF_DAY_TYPES.PM,
                        }));
                      }}
                    >
                      {formValues.halfDayPeriod === LEAVE_HALF_DAY_TYPES.PM &&
                        `✓`}{" "}
                      {LEAVE_HALF_DAY_TYPES.PM}
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="tw-flex tw-flex-col tw-gap-2">
              <label className="tw-font-medium">Description</label>
              <InputTextarea
                value={formValues.description ?? ""}
                onChange={(e) => {
                  setFormErrors((prev: any) => ({
                    ...prev,
                    description: null,
                  }));
                  setFormValues((prev: any) => ({
                    ...prev,
                    description: e.target.value,
                  }));
                }}
                rows={3}
                className={`${
                  formErrors.description
                    ? "tw-border-red-600"
                    : "tw-border-gray-400"
                } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-400 tw-rounded-md placeholder:tw-font-normal`}
                placeholder="Enter description"
              />
              <Button
                label={formType === "add" ? "Add Leave" : "Update Leave"}
                disabled={isAddButtonDisabled}
                className="tw-flex tw-px-3 focus:tw-shadow-none tw-py-2 tw-rounded-lg bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8"
                onClick={() => {
                  // Handle add leave logic here
                  handleAddUpdateMyLeaves(formType);
                }}
              />
            </div>
          </div>
        </Dialog>
        <Dialog
          className="comments-dialog"
          header={`Comments`}
          footer={null}
          visible={showManagerComments}
          draggable={false}
          style={{ maxWidth: "400px", minWidth: "300px" }}
          onHide={() => {
            if (!showManagerComments) return;
            setShowManagerComments(false);
          }}
        >
          <div className="tw-p-6">
            <div className="tw-p-4 tw-border-b tw-border-b-solid tw-border-b-[#DBDBDB]">
              <p className="tw-m-0 tw-text-center tw-text-base tw-font-normal tw-text-black">
                {approveRejectComments ?? "No comments added"}
              </p>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default MyLeaves;
